import { AppContext } from "../../Context.tsx";
import React, { Fragment, useState, useRef, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid2";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EventBlastTable from "../../components/Table/EventBlastTable.tsx";
import { useLocation } from "react-router-dom";
import TinyMCE from "../../components/EmailEditor/tinymce-email-builder.js";
import FileInput from "../../components/FileInput/FileInput";
import IconButton from "@mui/material/IconButton";
import BackspaceIcon from "@mui/icons-material/Backspace";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import axios from "axios";

//icomponents
import FileSelector from "../../i-components/FileSelector.tsx";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor.js";
import IFile from "../../i-classes/ifile.tsx";
import Checker from '../../i-components/Checker.tsx';

//icontrollers
import DatabaseInterfaceController from "../../i-controllers/DatabaseInterfaceController.tsx";

//usewaypoint, EmailBuilder.js components
import { renderToStaticMarkup } from '@usewaypoint/email-builder';

//muis
import SaveIcon from '@mui/icons-material/Save';
import PreviewIcon from '@mui/icons-material/Preview';

const nonstate = {
  emailBuilderUrl: "https://www.ppkm.org.my/ppkm-email-builder/",
  eblastControlUrl: "https://www.ppkm.org.my/mobile_backend/scripts/eblastControl.php",
  secret: "ppkm_14082024_mobile",
};

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Dashboard = () => {
  // tabs handle change
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const {
    register,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {},
  });

  const fileInputRef = useRef(null); // Create a ref for the file input
  const [clearFileInput, setClearFileInput] = useState(false);
  const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB in bytes

  const location = useLocation();
  const pathname = location.pathname;

  const [eblastID, SetEblastID] = useState("");
  const [templateID, SetTemplateID] = useState("");
  const [emailContent, setEmailContent] = useState(""); // State to store the edited content
  // const [attachment, setAttachment] = useState(); ---deprecated of unuse
  const [emailSubject, setEmailSubject] = useState("");
  const contentEditorRef = useRef(null);
  const footerEditorRef = useRef(null);

  //edited by delon 2025-05-28
  const [attachments, SetAttachments] = useState([]);
  const [previewJSON, SetPreviewJSON] = useState(null);
  const encryptor = new InfinityEncryptor("22499", "MYDIH");
  const [footerSignature, SetFooterSignature] = useState("");
  const appContext = useContext(AppContext);
  const database = new DatabaseInterfaceController(appContext);
  const [shouldAddAndroidLinkFooter, SetShouldAddAndroidLinkFooter] = useState(true);
  const [shouldAddIosLinkFooter, SetShouldAddIosLinkFooter] = useState(true);
  const [shouldAddPPKLogoHeader, SetShouldAddPPKLogoHeader] = useState(true);

  const handleClearFileInput = () => {
    setClearFileInput((prev) => !prev);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset input value to ensure onChange triggers again
    }
    // if (!fileInputRef.current) {
    //   setAttachment("");
    // }
  };

  const handleChangeEmailSubject = (e) => {
    setEmailSubject(e.target.value);
  };

  //initialize
  useEffect(() => {
    database.Queue("fetchFooterSignature", [["fetchFooterSignature", "true"]]);
  }, []);

  //watch for locationPathname update
  useEffect(() => {
    const pathnameArr = location.pathname.split("/");
    if (pathnameArr[pathnameArr.length - 1] != "event_blast") {
      const emailID = pathnameArr[pathnameArr.length - 1];
      //fetch email draft by emailID

      const formData = new FormData();
      formData.append("s3cr3t", encryptor.Encrypt("ppkm_14082024_mobile"));
      formData.append("fetchEmailDraftByID", encryptor.Encrypt("true"));
      formData.append("autoID", encryptor.Encrypt(emailID));

      axios
        .post(nonstate.eblastControlUrl, formData, { withCredentials: false })
        .then((res) => {
          if (!JSON.stringify(res.data).includes("_false")) {
            let resObj = {};
            try {
              resObj = JSON.parse(res.data);
            } catch {
              resObj = res.data;
            }

            const regex = /<!--\s*SECTION_START\s*-->([\s\S]*?)<!--\s*SECTION_END\s*-->/gi;
            //0-emailContent, 1-attachments
            const emailContentSections = [];
            let match;
            while ((match = regex.exec(resObj["email_content"])) !== null) {
              emailContentSections.push(match[1].trim()); // grab only content inside
            }

            let attachmentSection = undefined;

            if(emailContentSections.length > 1) {
              attachmentSection = emailContentSections[1];
            }

            

            // let logoSection;
            // let contentSection;
            // let footerSignatureSection;
            // let appLinkSection;
            // let attachmentSection;
            // if (emailContentSections[0].includes("logo-img")) {
            //   logoSection = emailContentSections[0];
            //   contentSection = emailContentSections[1];
            //   footerSignatureSection = emailContentSections[2];
            //   appLinkSection = emailContentSections[3];
            //   attachmentSection = emailContentSections[4];
            // } else {
            //   contentSection = emailContentSections[0];
            //   footerSignatureSection = emailContentSections[1];
            //   appLinkSection = emailContentSections[2];
            //   attachmentSection = emailContentSections[3];
            // } ---deprecated to new implementation

            //new implementation 2025-11-18


            if (resObj["blasted"] == "0") SetEblastID(resObj["autoID"]);

            SetTemplateID(resObj["autoID"]);

            setEmailSubject(resObj["email_subject"]);
            // setEmailContent(contentSection); //only get the first section, last two sections (app links, attachments) ignored ---deprecated to new implementation

            // if (contentEditorRef && contentEditorRef.current) contentEditorRef.current.content = contentSection; ---deprecated to new implementation

            //attachments
            if (attachmentSection != undefined && emailContentSections.length > 0) {
              // const attachmentSection = emailContentSections[3];
              const regex = /href="([^"]*)"/gi;
              match = attachmentSection.match(regex);
              let attachmentUrls = [...attachmentSection.matchAll(/href="([^"]*)"/gi)].map((m) => m[1]);
              attachmentUrls = FilterDupplicatedUrl(attachmentUrls);
              const _attachments = [];
              attachmentUrls.map((url) => {
                const urlArr = url.split("/");
                const fileName = urlArr[urlArr.length - 1];
                _attachments.push(new IFile(null, fileName, url));
              });
              SetAttachments([..._attachments]);
            }
          } else {
            console.log("fetchDraftErr " + JSON.stringify(res));
          }
        })
        .catch((err) => {
          console.log("fetchDraftErr " + err);
        });
    }
  }, [location.pathname]);

  //watch for databaseResultAction
  useEffect(() => {
    if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
      const ExecuteDatabaseResultAction = async () => {
        const [res, mode] = await appContext.databaseResultAction();

        if (!JSON.stringify(res).includes("_false")) {
          switch (mode) {
            case "fetchFooterSignature":
              SetFooterSignature(res);

              if (footerEditorRef && footerEditorRef.current) footerEditorRef.current.content = res;
              break;
            case "updateFooterSignature":
              break;
          }
        } else {
          console.log("ExecuteDatabaseResultActionErr: " + mode + " " + res);
        }
      };

      switch (appContext.databaseActionModeQueue[0]) {
        case "fetchFooterSignature":
        case "updateFooterSignature":
          ExecuteDatabaseResultAction();
          break;
      }
    }
  }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

  //watch for previewJSON, logoHeader, linkFooter update emailContent
  useEffect(() => {
    if(previewJSON) {
      const _emailContent = (shouldAddPPKLogoHeader ? RenderPPKLogoHeader() : '') + renderToStaticMarkup(previewJSON, { rootBlockId: 'root' }) + RenderAppLinkFooter(shouldAddAndroidLinkFooter, shouldAddIosLinkFooter);
      setEmailContent(_emailContent);
    }
  }, [previewJSON, shouldAddPPKLogoHeader, shouldAddAndroidLinkFooter, shouldAddIosLinkFooter]);

  //save as draft section
  const [shouldShowWaitScreen, SetShouldShowWaitScreen] = useState(false);
  const attachmentUrlsRef = useRef([]);
  const waitForAttachmentUploadFinishIntervalRef = useRef(null);
  const OnSaveAsDraftClicked = () => {
    SetShouldShowWaitScreen(true);

        //fetch blast_temp_json from server

    const encryptor = new InfinityEncryptor("22499", "MYDIH");

    const formData = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt("ppkm_14082024_mobile"));
    formData.append('getBlastTempJSON', encryptor.Encrypt('true'));
    
    axios.post(nonstate.eblastControlUrl, formData, { withCredentials: false }).then((res) => {
      const data = res.data;
      console.log('checkResData: ' + JSON.stringify(res.data));

      if(!JSON.stringify(data).includes('_false')) {
        let jsonObj = {};
        try {
          jsonObj = JSON.parse(data);
        } catch {
          jsonObj = data;
        }
        
        //ProceedSaveDraft
        ProceedSaveDraft(jsonObj);

      } else {
        console.log('getBlastTempJSONErr ' + data);
      }
    }).catch((err) => {
      console.log('getBlastTempJSONErr ' + err);
    });

    //save footer signature
    // SaveFooterSignatureToServer(); ---deprecated

  };
  const ProceedSaveDraft = (_previewJSON) => {
    //before save, prepare attachment links
    //upload attachments to server, get links
    attachmentUrlsRef.current = [];
    //check existing attachments
    attachments.map((attachment) => {
      if (attachment.base64.includes("https://")) attachmentUrlsRef.current.push(attachment.base64);
    });

    const blastID = new Date().getTime().toString();

    attachments.map((attachment) => {
      //check if the attachment already exist in server (http - means base64 is a url on server)
      if (!attachment.base64.includes("https://")) {
        // const base64s = ChunkBase64(attachment.base64);

        const formData = new FormData();
        formData.append("s3cr3t", encryptor.Encrypt("ppkm_14082024_mobile"));
        formData.append("uploadEBlastAttachment", encryptor.Encrypt("true"));
        formData.append("blastID", encryptor.Encrypt(blastID));
        formData.append("fileName", encryptor.Encrypt(attachment.GetFileName()));
        formData.append("base64", "NOENCRYPT" + attachment.base64);

        axios
          .post(nonstate.eblastControlUrl, formData, { withCredentials: false })
          .then((res) => {
            if (!res.data.includes("_false")) {
              //file upload success
              attachmentUrlsRef.current.push(res.data);
              console.log("file uploaded successful!: ");
            } else {
              console.log("fileUploadErr: " + res);
              alert("Attachment upload failed, please try again.");
              attachmentUrlsRef.current = [];

              if (waitForAttachmentUploadFinishIntervalRef.current != null) {
                clearInterval(waitForAttachmentUploadFinishIntervalRef.current);
                waitForAttachmentUploadFinishIntervalRef.current = null;
              }
            }
          })
          .catch((err) => {
            console.log("err: " + err);
            alert("Attachment upload failed, please try again.");
            SetShouldShowWaitScreen(false);
            attachmentUrlsRef.current = [];

            if (waitForAttachmentUploadFinishIntervalRef.current != null) {
              clearInterval(waitForAttachmentUploadFinishIntervalRef.current);
              waitForAttachmentUploadFinishIntervalRef.current = null;
            }
          });
      }
    });

    if (waitForAttachmentUploadFinishIntervalRef.current != null) {
      clearInterval(waitForAttachmentUploadFinishIntervalRef.current);
    }

    waitForAttachmentUploadFinishIntervalRef.current = setInterval(async () => {
      if (attachments.length == attachmentUrlsRef.current.length) {
        //clear interval
        clearInterval(waitForAttachmentUploadFinishIntervalRef.current);
        waitForAttachmentUploadFinishIntervalRef.current = null;

        console.log("saving draft");

        //all attachmets uploaded complete, proceed to save draft

        //add attachment contents to the emailContent
        let attachmentContent = "<!-- SECTION_START -->";

        attachmentContent += "<b>" + attachmentUrlsRef.current.length.toString() + " attachments</b></br>";
        //open container
        attachmentContent += '<div style="position: relative; width: 100%; height: auto; padding: 10px; overflow-x: auto; overflow-y: hidden; display: flex; justify-content: flex-start; align-items: center; flex-wrap: wrap;">';

        attachmentUrlsRef.current.map((url) => {
          // $fileArr = explode('.', $url);
          // $fileExtension = $fileArr[sizeof($fileArr) - 1];
          const fileArr = url.split(".");
          const fileExtension = fileArr[fileArr.length - 1];

          // $urlArr = explode('/', $url);
          // $fileName = $urlArr[sizeof($urlArr) - 1];
          const urlArr = url.split("/");
          const fileName = urlArr[urlArr.length - 1];

          // if($this->IsPDF($fileExtension)) {
          //     $attachmentContent .= $this->GeneratePDFLinkButton($url, $fileExtension, (strlen($fileName) > 17 ? substr($fileName, 0, 17) . ' ...' : $fileName));
          // } else if($this->IsDoc($fileExtension)) {
          //     $attachmentContent .= $this->GenerateWordLinkButton($url, $fileExtension, (strlen($fileName) > 17 ? substr($fileName, 0, 17) . ' ...' : $fileName));
          // } else if($this->IsExcel($fileExtension)) {
          //     $attachmentContent .= $this->GenerateExcelLinkButton($url, $fileExtension, (strlen($fileName) > 17 ? substr($fileName, 0, 17) . ' ...' : $fileName));
          // } else if($this->IsPNG($fileExtension)) {
          //     $attachmentContent .= $this->GeneratePNGLinkButton($url, $fileExtension, (strlen($fileName) > 17 ? substr($fileName, 0, 17) . ' ...' : $fileName));
          // } else if($this->IsJPEG($fileExtension)) {
          //     $attachmentContent .= $this->GenerateJPEGLinkButton($url, $fileExtension, (strlen($fileName) > 17 ? substr($fileName, 0, 17) . ' ...' : $fileName));
          // } else {
          //     $attachmentContent .= $this->GenerateUnknownLinkButton($url, $fileExtension, (strlen($fileName) > 17 ? substr($fileName, 0, 17) . ' ...' : $fileName));
          // }

          if (IsPDF(fileExtension)) {
            attachmentContent += GeneratePDFLinkButton(url, fileExtension, fileName.length > 17 ? fileName.substring(0, 17) + " ..." : fileName);
          } else if (IsDoc(fileExtension)) {
            attachmentContent += GenerateWordLinkButton(url, fileExtension, fileName.length > 17 ? fileName.substring(0, 17) + " ..." : fileName);
          } else if (IsExcel(fileExtension)) {
            attachmentContent += GenerateExcelLinkButton(url, fileExtension, fileName.length > 17 ? fileName.substring(0, 17) + " ..." : fileName);
          } else if (IsPNG(fileExtension)) {
            attachmentContent += GeneratePNGLinkButton(url, fileExtension, fileName.length > 17 ? fileName.substring(0, 17) + " ..." : fileName);
          } else if (IsJPEG(fileExtension)) {
            attachmentContent += GenerateJPEGLinkButton(url, fileExtension, fileName.length > 17 ? fileName.substring(0, 17) + " ..." : fileName);
          } else {
            attachmentContent += GenerateUnknownLinkButton(url, fileExtension, fileName.length > 17 ? fileName.substring(0, 17) + " ..." : fileName);
          }
        });

        attachmentContent += "</div>"; //closing container

        attachmentContent += "<!-- SECTION_END -->";

        //add empty blank app link section before attachment section
        let _emailContent = (shouldAddPPKLogoHeader ? RenderPPKLogoHeader() : '') + renderToStaticMarkup(_previewJSON, { rootBlockId: 'root' }) + RenderAppLinkFooter(shouldAddAndroidLinkFooter, shouldAddIosLinkFooter);
        _emailContent = "<!-- SECTION_START -->" + _emailContent + "<!-- SECTION_END -->"; //wrap first email content into section
        //add footer signature
        // _emailContent += "<!-- SECTION_START -->" + footerSignature + "<!-- SECTION_END -->"; //add footer signature
        // _emailContent += "<!-- SECTION_START --><!-- SECTION_END -->"; //empty section for app link ---deprecated
        //add attachments section
        _emailContent += "<br/><br/><br/>" + attachmentContent;

        const encryptor = new InfinityEncryptor("22499", "MYDIH");
        const formData = new FormData();
        formData.append("saveDraft", encryptor.Encrypt("true"));
        formData.append("s3cr3t", encryptor.Encrypt(nonstate.secret));
        formData.append("autoID", encryptor.Encrypt(eblastID));
        formData.append("email_subject", encryptor.Encrypt(emailSubject));
        formData.append("email_content", encryptor.Encrypt(_emailContent));
        formData.append("email_template", encryptor.Encrypt(JSON.stringify(_previewJSON, null, '  ').replace(/\\n/g, '\\\\n').replace(/'/g, "''")));

        axios
          .post(nonstate.eblastControlUrl, formData, { withCredentials: false })
          .then((res) => {
            if (!JSON.stringify(res.data).includes("_false")) {
              alert("Draft saved successfully !");
            } else {
              alert("Failed, Draft not saved !");
              console.log("saveDraftErr: " + JSON.stringify(res));
            }
            SetShouldShowWaitScreen(false);
          })
          .catch((err) => {
            alert("Failed, Draft not saved !");
            console.log("saveDraftErr: " + err);
            SetShouldShowWaitScreen(false);
          });
      }
    }, nonstate.waitForAttachmentUploadInterval);
  }
  const IsPDF = (ex) => {
    if (ex.toLowerCase() == "pdf") return true;
    else return false;
  };
  const IsDoc = (ex) => {
    if (ex.toLowerCase() == "doc" || ex.toLowerCase() == "docx" || ex.toLowerCase() == "odt") {
      return true;
    } else return false;
  };
  const IsExcel = (ex) => {
    if (ex.toLowerCase() == "xlsx" || ex.toLowerCase() == "xlsm" || ex.toLowerCase() == "xltx" || ex.toLowerCase() == "xltm" || ex.toLowerCase() == "xls" || ex.toLowerCase() == "xlt" || ex.toLowerCase() == "xlsb" || ex.toLowerCase() == "xlam") {
      return true;
    } else return false;
  };
  const IsPNG = (ex) => {
    if (ex.toLowerCase() == "png") {
      return true;
    } else return false;
  };
  const IsJPEG = (ex) => {
    if (ex.toLowerCase() == "jpg" || ex.toLowerCase() == "jpeg") {
      return true;
    } else {
      return false;
    }
  };
  const GeneratePDFLinkButton = (link, fileExtension, fileName) => {
    const html = `
                    <a href="${link}"
                        style="position: relative; width: 200px; height: 160px; text-decoration: none !important; margin: 5px;">
                        <table cellpadding="0" cellspacing="0" border="0" style="width: 200px; border: 1px solid #ccc; border-radius: 6px; font-family: Arial, sans-serif; text-decoration: none; box-sizing: border-box;">
                            <tr>
                                <td style="
                                    background-color: #e9e9e9; height: 120px; border-radius: 6px 6px 0px 0px;
                                    text-align: center; font-size: 20px; font-weight: bold; color: #4d4d4d;
                                ">
                                    <a href="${link}" style="text-decoration: none !important; color: #4d4d4d;">
                                        ${fileExtension.toUpperCase()}
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td style="
                                    padding: 8px 12px; border-radius: 0px 0px 6px 6px;
                                    background-color: #ffffff;
                                ">
                                    <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                        <tr>
                                            <td style="
                                                width: 30px; height: 30px;
                                                background-color: #d63333; border-radius: 3px;
                                                text-align: center; font-size: 12px; font-weight: bold; color: #ffffff;
                                            ">
                                                PDF
                                            </td>
                                            <td style="
                                                overflow: hidden; padding-left: 6px;
                                                font-size: 12px; color: #333333; white-space: nowrap; text-overflow: ellipsis;
                                            ">
                                                <a href="${link}" style="text-decoration: none !important; color: #333333;">
                                                    ${fileName}
                                                </a>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </a>
                    `;
    return html;
  };
  const GenerateWordLinkButton = (link, fileExtension, fileName) => {
    const html = `
    <a href="${link}"
        style="position: relative; width: 200px; height: 160px; text-decoration: none !important; margin: 5px;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 200px; border: 1px solid #ccc; border-radius: 6px; font-family: Arial, sans-serif; text-decoration: none; box-sizing: border-box;">
            <tr>
                <td style="
                    background-color: #e9e9e9; height: 120px; border-radius: 6px 6px 0px 0px;
                    text-align: center; font-size: 20px; font-weight: bold; color: #4d4d4d;
                ">
                    <a href="${link}" style="text-decoration: none !important; color: #4d4d4d;">
                        ${fileExtension.toUpperCase()}
                    </a>
                </td>
            </tr>
            <tr>
                <td style="
                    padding: 8px 12px; border-radius: 0px 0px 6px 6px;
                    background-color: #ffffff;
                ">
                    <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                        <tr>
                            <td style="
                                width: 30px; height: 30px;
                                background-color: #115799; border-radius: 3px;
                                text-align: center; font-size: 12px; font-weight: bold; color: #ffffff;
                            ">
                                DOC
                            </td>
                            <td style="
                                overflow: hidden; padding-left: 6px;
                                font-size: 12px; color: #333333; white-space: nowrap; text-overflow: ellipsis;
                            ">
                                <a href="${link}" style="text-decoration: none !important; color: #333333;">
                                    ${fileName}
                                </a>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </a>
    `;

    return html;
  };
  const GenerateExcelLinkButton = (link, fileExtension, fileName) => {
    const html = `
    <a href="${link}"
        style="position: relative; width: 200px; height: 160px; text-decoration: none !important; margin: 5px;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 200px; border: 1px solid #ccc; border-radius: 6px; font-family: Arial, sans-serif; text-decoration: none; box-sizing: border-box;">
            <tr>
                <td style="
                    background-color: #e9e9e9; height: 120px; border-radius: 6px 6px 0px 0px;
                    text-align: center; font-size: 20px; font-weight: bold; color: #4d4d4d;
                ">
                    <a href="${link}" style="text-decoration: none !important; color: #4d4d4d;">
                        ${fileExtension.toUpperCase()}
                    </a>
                </td>
            </tr>
            <tr>
                <td style="
                    padding: 8px 12px; border-radius: 0px 0px 6px 6px;
                    background-color: #ffffff;
                ">
                    <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                        <tr>
                            <td style="
                                width: 30px; height: 30px;
                                background-color: #0f9d58; border-radius: 3px;
                                text-align: center; font-size: 12px; font-weight: bold; color: #ffffff;
                            ">
                                X
                            </td>
                            <td style="
                                overflow: hidden; padding-left: 6px;
                                font-size: 12px; color: #333333; white-space: nowrap; text-overflow: ellipsis;
                            ">
                                <a href="${link}" style="text-decoration: none !important; color: #333333;">
                                    ${fileName}
                                </a>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </a>
    `;

    return html;
  };
  const GeneratePNGLinkButton = (link, fileExtension, fileName) => {
    const html = `
    <a href="${link}"
        style="position: relative; width: 200px; height: 160px; text-decoration: none !important; margin: 5px;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 200px; border: 1px solid #ccc; border-radius: 6px; font-family: Arial, sans-serif; text-decoration: none; box-sizing: border-box;">
            <tr>
                <td style="
                    background-color: #e9e9e9; height: 120px; border-radius: 6px 6px 0px 0px;
                    text-align: center; font-size: 20px; font-weight: bold; color: #4d4d4d;
                ">
                    <a href="${link}" style="text-decoration: none !important; color: #4d4d4d;">
                        ${fileExtension.toUpperCase()}
                    </a>
                </td>
            </tr>
            <tr>
                <td style="
                    padding: 8px 12px; border-radius: 0px 0px 6px 6px;
                    background-color: #ffffff;
                ">
                    <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                        <tr>
                            <td style="
                                width: 30px; height: 30px;
                                background-color: #71840f; border-radius: 3px;
                                text-align: center; font-size: 12px; font-weight: bold; color: #ffffff;
                            ">
                                PNG
                            </td>
                            <td style="
                                overflow: hidden; padding-left: 6px;
                                font-size: 12px; color: #333333; white-space: nowrap; text-overflow: ellipsis;
                            ">
                                <a href="${link}" style="text-decoration: none !important; color: #333333;">
                                    ${fileName}
                                </a>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </a>
    `;
    return html;
  };
  const GenerateJPEGLinkButton = (link, fileExtension, fileName) => {
    const html = `
      <a href="${link}"
          style="position: relative; width: 200px; height: 160px; text-decoration: none !important; margin: 5px;">
          <table cellpadding="0" cellspacing="0" border="0" style="width: 200px; border: 1px solid #ccc; border-radius: 6px; font-family: Arial, sans-serif; text-decoration: none; box-sizing: border-box;">
              <tr>
                  <td style="
                      background-color: #e9e9e9; height: 120px; border-radius: 6px 6px 0px 0px;
                      text-align: center; font-size: 20px; font-weight: bold; color: #4d4d4d;
                  ">
                      <a href="${link}" style="text-decoration: none !important; color: #4d4d4d;">
                          ${fileExtension.toUpperCase()}
                      </a>
                  </td>
              </tr>
              <tr>
                  <td style="
                      padding: 8px 12px; border-radius: 0px 0px 6px 6px;
                      background-color: #ffffff;
                  ">
                      <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                          <tr>
                              <td style="
                                  width: 30px; height: 30px;
                                  background-color: #578823; border-radius: 3px;
                                  text-align: center; font-size: 9px; font-weight: bold; color: #ffffff;
                              ">
                                  JPEG
                              </td>
                              <td style="
                                  overflow: hidden; padding-left: 6px;
                                  font-size: 12px; color: #333333; white-space: nowrap; text-overflow: ellipsis;
                              ">
                                  <a href="${link}" style="text-decoration: none !important; color: #333333;">
                                      ${fileName}
                                  </a>
                              </td>
                          </tr>
                      </table>
                  </td>
              </tr>
          </table>
      </a>
      `;
    return html;
  };
  const GenerateUnknownLinkButton = (link, fileExtension, fileName) => {
    const html = `
    <a href="${link}"
        style="position: relative; width: 200px; height: 160px; text-decoration: none !important; margin: 5px;">
        <table cellpadding="0" cellspacing="0" border="0" style="width: 200px; border: 1px solid #ccc; border-radius: 6px; font-family: Arial, sans-serif; text-decoration: none; box-sizing: border-box;">
            <tr>
                <td style="
                    background-color: #e9e9e9; height: 120px; border-radius: 6px 6px 0px 0px;
                    text-align: center; font-size: 20px; font-weight: bold; color: #4d4d4d;
                ">
                    <a href="${link}" style="text-decoration: none !important; color: #4d4d4d;">
                        ${fileExtension.toUpperCase()}
                    </a>
                </td>
            </tr>
            <tr>
                <td style="
                    padding: 8px 12px; border-radius: 0px 0px 6px 6px;
                    background-color: #ffffff;
                ">
                    <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                        <tr>
                            <td style="
                                width: 30px; height: 30px;
                                background-color: #575159; border-radius: 3px;
                                text-align: center; font-size: 12px; font-weight: bold; color: #ffffff;
                            ">
                                ?
                            </td>
                            <td style="
                                overflow: hidden; padding-left: 6px;
                                font-size: 12px; color: #333333; white-space: nowrap; text-overflow: ellipsis;
                            ">
                                <a href="${link}" style="text-decoration: none !important; color: #333333;">
                                    ${fileName}
                                </a>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </a>
    `;

    return html;
  };
  const SaveFooterSignatureToServer = () => {
    database.Queue("updateFooterSignature", [
      ["updateFooterSignature", "true"],
      ["footerSignature", footerSignature],
    ]);
  };

  //generate preview section
  const OnGeneratePreviewClicked = () => {
    //fetch blast_temp_json from server

    const encryptor = new InfinityEncryptor("22499", "MYDIH");

    const formData = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt("ppkm_14082024_mobile"));
    formData.append('getBlastTempJSON', encryptor.Encrypt('true'));
    
    axios.post(nonstate.eblastControlUrl, formData, { withCredentials: false }).then((res) => {
      const data = res.data;
      console.log('checkResData: ' + res.data);

      if(!JSON.stringify(data).includes('_false')) {
        let jsonObj = {};
        try {
          jsonObj = JSON.parse(data);
        } catch {
          jsonObj = data;
        }
        SetPreviewJSON(jsonObj);
      } else {
        console.log('getBlastTempJSONErr ' + data);
      }
    }).catch((err) => {
      console.log('getBlastTempJSONErr ' + err);
    });
  };

  //exe functions
  const FilterDupplicatedUrl = (urls) => {
    const res = [];
    urls.map((url) => {
      let notFound = true;
      res.map((re) => {
        if (re == url) notFound = false;
      });
      if (notFound) res.push(url);
    });

    return res;
  };

  //render functions
  const RenderPPKLogoHeader = () => {
    return "<table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n" +
            "  <tr>\n" +
            "    <td align=\"center\">\n" +
            "      <img src=\"https://www.ppkm.org.my/ppkm/ppkmLogo.jpg\" width=\"150\" height=\"150\" style=\"display: block; border: 0;\" alt=\"PPKM Logo\"/>\n" +
            "    </td>\n" +
            "  </tr>\n" +
            "</table>";
  }
  const RenderAppLinkFooter = (android, ios) => {
    if(android || ios) {
      return "<table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n" +
              "  <tr>\n" +
              (
                android ?
                "    <td align=\"center\" style=\"padding: 10px 10px;\">\n" +
                "      <a href=\"https://play.google.com/store/apps/details?id=com.neudimenxion.PPKM_SuperApp\" style=\"margin: 5px; text-decoration: none;\">\n" +
                "        <img src=\"https://www.ppkm.org.my/mobile_backend/assets/icons/googleAppLinkBadge.jpeg\" width=\"150\" height=\"50\" style=\"display: block; margin: 5px; border: 0;\" alt=\"Google Play\"/>\n" +
                "      </a>\n" +
                "    </td>\n"
                :
                ""
              ) +
              (
                ios ?
                "    <td align=\"center\" style=\"padding: 10px 10px;\">\n" +
                "      <a href=\"https://apps.apple.com/bh/app/ppkm-super-app/id6736516881\" style=\"margin: 5px; text-decoration: none;\">\n" +
                "        <img src=\"https://www.ppkm.org.my/mobile_backend/assets/icons/iosAppLinkBadge.jpeg\" width=\"150\" height=\"50\" style=\"display: block; margin: 5px; border: 0;\" alt=\"App Store\"/>\n" +
                "      </a>\n" +
                "    </td>\n"
                :
                ""
              ) +
              "  </tr>\n" +
              "</table>";
    } else {
      return "";
    }
  }

  //watchers
  // useEffect(() => {
  //   console.log('event_blastTest: ' + JSON.stringify(attachments));
  // }, [attachments]);

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        width: "100vw",
      }}
    >
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Typography component="div" variant="h5">
          <Box sx={{ fontWeight: "bold", m: 1 }}> </Box>
        </Typography>

        {pathname.includes("/admin/event_blast") && (
          <>
            <Grid container spacing={2} alignItems="center" mt={2}>
              <Grid size={2}>
                <Typography fontWeight="bold">Subject</Typography>
              </Grid>
              <Grid size={10}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      fontSize: "16px",
                      borderRadius: "25px",
                      color: "black", // Set the input text color to black
                      backgroundColor: "white", // Set background color to white
                      "& fieldset": {
                        borderColor: "#ccc", // Default border color
                      },
                      "&:hover fieldset": {
                        borderColor: "#999", // Border color on hover
                      },
                    },
                  }}
                  onChange={handleChangeEmailSubject}
                  value={emailSubject}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center" mt={2}>
              <Grid size={2}>
                <Typography fontWeight="bold">Attachment</Typography>
              </Grid>
              <Grid size={10}>
                {/*<FileInput
                  label="Choose"
                  name="document"
                  control={control}
                  rules={{ required: false }}
                  helperText={errors.document && errors.document.message}
                  inputRef={fileInputRef} // Assign the ref to the FileInput component
                  // onClearInput={clearFileInput}
                  {...register("document", {
                    required: false,
                    validate: (fileList) => {
                      if (
                        fileList &&
                        fileList.length > 0
                        //&& fileList[0].size > MAX_FILE_SIZE
                      ) {
                        let sizeLimitExceed = false;
                        fileList.map((file) => {
                            if(file.size > MAX_FILE_SIZE)
                              sizeLimitExceed = true;
                        })

                        if(sizeLimitExceed)
                          return "File size exceeds the 20MB limit.";
                      }
                      return true;
                    },
                    onChange: (e) => {
                      const selectedFile = e.target.value[0]; // Get the selected file
                      setAttachment(selectedFile);
                    },
                  })}
                /> --deprecated*/}
                <FileSelector files={attachments} SetFiles={SetAttachments} fileSizeLimit={30} />
              </Grid>

              {/* <Grid size={6}>
                <Tooltip title="Remove File">
                  <IconButton
                    aria-label="delete"
                    onClick={handleClearFileInput}
                    sx={{
                      backgroundColor: "#eee",
                      "&:hover": { backgroundColor: "#ddd" },
                      borderRadius: "8px",
                      marginBottom: "25px",
                    }}
                  >
                    <BackspaceIcon color="error" />
                  </IconButton>
                </Tooltip>
              </Grid> */}
            </Grid>

            <Typography component="div">
              <Box sx={{ fontWeight: "bold" }}>E-mail Content</Box>
            </Typography>

            {/* <Controller
              name="emailContent"
              control={control}
              defaultValue={''}
              rules={{ required: "This field is required" }}
              render={({ field: { onChange, value } }) => (
                <TinyMCE
                  ref={contentEditorRef}
                  existingContent={emailContent}
                  onContentChange={(content) => {
                    onChange(content); // Ensure react-hook-form gets the updated content
                    setEmailContent(content); // Update local state
                  }}
                />
              )}
            /> */}
            <iframe src={nonstate.emailBuilderUrl + "?responseUrl=https://www.ppkm.org.my/mobile_backend/scripts/emailBuilderControl.php" + (templateID != '' ? "&templateID=" + templateID : "")} width="100%" height="720px" />
            {/*<br />
            <Typography component="div">
              <Box sx={{ fontWeight: "bold" }}>Footer Signature</Box>
            </Typography>
            <Controller
              name="footerSignature"
              control={control}
              defaultValue={""}
              rules={{ required: "This field is required" }}
              render={({ field: { onChange, value } }) => (
                <TinyMCE
                  ref={footerEditorRef}
                  existingContent={footerSignature}
                  onContentChange={(content) => {
                    onChange(content); // Ensure react-hook-form gets the updated content
                    SetFooterSignature(content); // Update local state
                  }}
                />
              )}
            /> ---deprecated, footer signature move to ppkm-email-builder app*/}

            <div className='main-row' style={{position: 'relative', width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
              <Checker label='include PPK Logo' checked={shouldAddPPKLogoHeader} SetChecked={SetShouldAddPPKLogoHeader} style={{margin: '10px'}}/>
              <Checker label='include Android App Link' checked={shouldAddAndroidLinkFooter} SetChecked={SetShouldAddAndroidLinkFooter} style={{margin: '10px'}}/>
              <Checker label='include IOS App Link' checked={shouldAddIosLinkFooter} SetChecked={SetShouldAddIosLinkFooter} style={{margin: '10px'}}/>
            </div>

            {/** -- generate previes / save draft buttons -- */}
            <div className="main-col" style={{ width: "100%", height: "auto", display: "flex", flexDirection: 'column', justifyContent: "flex-end", alignItems: "center" }}>
              <button className="main-col-btn" style={{ margin: "5px", padding: "5px", width: "100%", flexShrink: "0", backgroundColor: "#d33333", color: "#ffffff", borderRadius: "10px", borderWidth: "0px" }} onClick={() => OnGeneratePreviewClicked()}>
                <PreviewIcon style={{marginRight: '10px', fontSize: '35px'}}/>
                Generate Preview
              </button>
              <button className="main-col-btn" style={{ margin: "5px", padding: "5px", width: "100%", flexShrink: "0", backgroundColor: "#d33333", color: "#ffffff", borderRadius: "10px", borderWidth: "0px" }} onClick={() => OnSaveAsDraftClicked()}>
                <SaveIcon style={{marginRight: '10px', fontSize: '35px'}}/>
                Save As Draft
              </button>
            </div>
          </>
        )}

        {/** only show blast email table card after preview is generated */}
        {
          previewJSON != null ? (
            <Fragment>
              <div className='preview-panel' style={{position: 'relative', width: '100%', height: 'auto', display: 'flex', flexDirection: 'column', padding: '20px', backgroundColor: '#ffffff', transform: 'scale(0.7)'}} dangerouslySetInnerHTML={{__html: emailContent}}/>
              <Card variant="outlined" sx={{ mt: 6, mb: 6 }}>
                <CardContent>
                  <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs value={value} onChange={handleChange}>
                        <Tab label="Committees" {...a11yProps(0)} />
                        <Tab label="Members" {...a11yProps(1)} />
                      </Tabs>
                    </Box>

                    <CustomTabPanel value={value} index={0}>
                      <EventBlastTable emailContent={emailContent} emailSubject={emailSubject} attachments={attachments} emailTemplate={JSON.stringify(previewJSON).replace(/\\n/g, '\\\\n')} event_categoryID="5" />
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                      <EventBlastTable emailContent={emailContent} emailSubject={emailSubject} attachments={attachments} emailTemplate={JSON.stringify(previewJSON).replace(/\\n/g, '\\\\n')} event_categoryID={""} />
                    </CustomTabPanel>
                  </Box>
                </CardContent>
              </Card>
            </Fragment>
          )
          :
          null
        }
        {shouldShowWaitScreen ? (
          <div className="wait-screen" style={{ position: "fixed", width: "100%", height: "100%", top: "0", left: "0", backgroundColor: "#000000AA" }}>
            <span className="screen-lbl">Please wait ...</span>
          </div>
        ) : null}
      </Box>
    </Box>
  );
};

export default Dashboard;
